import React from 'react';
import useTrack from '../../hooks/useTrack/useTrack';
import AudioTrack from '../AudioTrack/AudioTrack';
import VideoTrack from '../VideoTrack/VideoTrack';

import { IVideoTrack } from '../../types';
import {
  AudioTrack as IAudioTrack,
  LocalTrackPublication,
  Participant,
  RemoteTrackPublication,
  Track,
} from 'twilio-video';

interface PublicationProps {
  publication: LocalTrackPublication | RemoteTrackPublication;
  participant: Participant;
  isLocal: boolean;
  disableAudio?: boolean;
  videoPriority?: Track.Priority;
}

export default function Publication({ publication, isLocal, disableAudio, videoPriority }: PublicationProps) {
  const track = useTrack(publication);

  if (!track) return null;
  let videoClassName = "";
  
  if(track.kind === "video" && track.dimensions && track.dimensions.width && track.dimensions.height){
    if(track.dimensions.width > track.dimensions.height){
      videoClassName = "desktop-main-screen";
    }else{
      videoClassName = "mobile-main-screen";
    }
  }
  if(track.name === "screen" && isLocal){
    return <div className="screen-sharing">
      <div className="screen-sharing-content">
      Screen Sharing is on.
        </div>
      </div>
  }
  switch (track.kind) {
    case 'video':
      return (
        <div className={videoClassName}>
        <VideoTrack
          track={track as IVideoTrack}
          priority={videoPriority}
          isLocal={track.name === 'camera' && isLocal}
        />
        </div>
      );
    case 'audio':
      return disableAudio ? null : <AudioTrack track={track as IAudioTrack} />;
    default:
      return null;
  }
}
